import React, { useState } from 'react';
import { api } from '../config/api';

export const AITest: React.FC = () => {
  const [documentId, setDocumentId] = useState('');
  const [results, setResults] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const testDocument = async () => {
    if (!documentId.trim()) {
      alert('Please enter a document ID');
      return;
    }

    setLoading(true);
    try {
      // Get document details
      const response = await api.get(`/api/v1/documents/${documentId}`);
      const doc = response.data;
      
      setResults({
        success: true,
        document: {
          id: doc.id,
          filename: doc.filename,
          extracted_data: doc.extracted_data,
          ocr_text_length: doc.ocr_text?.length || 0,
          status: doc.status,
          vendor: doc.vendor_name,
          created_at: doc.created_at
        }
      });

      // Check if amount is a date
      if (doc.extracted_data?.amount) {
        const amount = doc.extracted_data.amount;
        const amountStr = String(amount).replace('.0', '');
        if (amountStr.length === 8 && amountStr.startsWith('20')) {
          setResults((prev: any) => ({
            ...prev,
            warning: `Amount appears to be a date: ${amount} (${amountStr.slice(0,4)}-${amountStr.slice(4,6)}-${amountStr.slice(6,8)})`
          }));
        }
      }
    } catch (error: any) {
      setResults({
        success: false,
        error: error.response?.data?.detail || error.message
      });
    }
    setLoading(false);
  };

  const reprocessDocument = async () => {
    if (!documentId.trim()) {
      alert('Please enter a document ID');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post(`/api/v1/documents/${documentId}/reprocess`);
      setResults({
        success: true,
        message: 'Document reprocessed',
        data: response.data
      });
    } catch (error: any) {
      setResults({
        success: false,
        error: error.response?.data?.detail || error.message
      });
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>AI Extraction Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <p>Enter a document ID to test AI extraction:</p>
        <input
          type="text"
          value={documentId}
          onChange={(e) => setDocumentId(e.target.value)}
          placeholder="Document ID (UUID)"
          style={{ 
            width: '400px', 
            padding: '8px', 
            marginRight: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px'
          }}
        />
        <button 
          onClick={testDocument} 
          disabled={loading}
          style={{ 
            padding: '8px 16px', 
            marginRight: '10px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          Test Document
        </button>
        <button 
          onClick={reprocessDocument} 
          disabled={loading}
          style={{ 
            padding: '8px 16px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          Reprocess
        </button>
      </div>

      <div style={{ marginBottom: '20px', fontSize: '14px', color: '#666' }}>
        <p>To find document IDs:</p>
        <ol>
          <li>Go to the Documents page</li>
          <li>Open browser console (F12)</li>
          <li>Click on a document</li>
          <li>Look for the ID in the URL or console logs</li>
        </ol>
      </div>

      {loading && <p>Loading...</p>}

      {results && (
        <div style={{ 
          marginTop: '20px', 
          padding: '20px', 
          backgroundColor: results.success ? '#f0f8ff' : '#fff0f0',
          border: `1px solid ${results.success ? '#007bff' : '#dc3545'}`,
          borderRadius: '4px'
        }}>
          {results.warning && (
            <div style={{ 
              padding: '10px', 
              backgroundColor: '#fff3cd', 
              border: '1px solid #ffc107',
              borderRadius: '4px',
              marginBottom: '10px'
            }}>
              ⚠️ {results.warning}
            </div>
          )}
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {JSON.stringify(results, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};